import React, { Component } from "react";
import { connect } from "react-redux";
import { getDataAction, editDataAction, deleteDataAction } from "../config/redux/action";
import { Icon, Button, Input } from "semantic-ui-react";
import { TableComp } from "../component/TableComp";
import { HeaderComp } from "./Akun/HeaderComp";
import { 
  Modal,
  ModalBody,  
  UncontrolledDropdown, 
  DropdownToggle, 
  DropdownMenu, 
  DropdownItem, 
  Form, 
  ModalHeader,
  ModalFooter,
  Input as PasswordInput
} from "reactstrap";
import { SelectPerusahaan } from "../component/Utils";
import { toast } from "react-toastify";
import { isBiro } from "../utils/helper";
import LoadingTop from "../component/LoadingTop";

class Akun extends Component {
  constructor() {
    super();
    this.state = {
      ValueShowData: 10,
      ValuePage: 0,
      searchName: "",
      typingTimeout: 0,
      modalChangeStatus: false,
      selectedUser: null,
      dropdownOpen: false,
      modalChangePassword: false,
      modalDeleteUser: false,
      password: "",
      loading: false
    };
  }

  componentDidMount() {
    this.props.filter.perusahaanFilter = null;
    this.getDataTable();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.filter.perusahaanFilter !== prevProps.filter.perusahaanFilter) {
      this.getDataTable();
    }
  }

  getData = () => {
    const { ValueShowData, ValuePage } = this.state;
    this.props.getData({
      path: `user?size=${ValueShowData}&page=${ValuePage}`,
      type: "GET_DATA_TABLE_AKUN",
    });
    this.getDataTable(10, 0);
  };

  getDataTable = () => {
    let { ValueShowData, ValuePage, searchName } = this.state;
    let search = "";
    if (searchName) {
      search = `&search=${searchName}`;
      ValuePage = 0;
    }
    if(this.props.filter.perusahaanFilter) {
      if(search === "") search = `&perusahaanId=${this.props.filter.perusahaanFilter}`;
      else search += `&perusahaanId=${this.props.filter.perusahaanFilter}`;
      ValuePage = 0;
    }

    this.props.getData({
      path: `user?size=${ValueShowData}&page=${ValuePage}${search}`,
      type: "GET_DATA_TABLE_AKUN",
    }).then(() => {});
  };

  openChangeStatuModal = (u) => {
    this.setState((prevState) => ({
      modalChangeStatus: !prevState.modalChangeStatus,
      selectedUser: u,
    }));
  };

  openDeleteModal = (u) => {
    this.setState((prevState) => ({
      modalDeleteUser: !prevState.modalDeleteUser,
      selectedUser: u,
    }));
  };

  changeUserStatus = () => {
    if (this.state.selectedUser == null) {
      toast.error("Anda belum memilih Akun");
      return;
    }
    const user = this.state.selectedUser;
    const p1 = user.status === 0 ? "user/enabled" : "user/disabled";
    const p2 = `${p1}/${user.id}`;
    this.props
      .changeStatus({
        path: p2,
        title: "Status Akun Pengguna",
      })
      .then((r) => {
        this.toggleModalChangeStatus();
        this.getData();
      });
  };

  handleChangePassword = () => {
    if (this.state.selectedUser == null) {
      toast.error("Anda belum memilih Akun");
      return;
    }
    const user = this.state.selectedUser;
    const password = this.state.password;
    const body = { email: user.email, password };
    const path = "user/change-password";

    this.setState(() => ({loading: true}));
    this.props.changePassword({
      path, body,
      title: "Data User"
    }).then(() => {
      this.toggleModalChangePassword()
      this.setState(() => ({loading: false}));
    });
  };

  handlePasswordInput = (value) => {
    this.setState(() => ({password: value}));
  };

  handlePagginateTable = (ValueShowData, ValuePage) => {
    this.setState(
      {
        ValueShowData: ValueShowData,
        ValuePage: ValuePage - 1,
      },
      () => {
        this.getDataTable();
      }
    );
  };
  
  formatterStatus = (cell, row) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle
          onClick={(e) => e.preventDefault()}
          caret
        >
          Aksi
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => this.openModalChangePassword(row)}>
            Ubah Password
          </DropdownItem>
          <DropdownItem divider />
          {this.props.user.role < 4 ? (
            <>
              <DropdownItem onClick={(e) => this.openChangeStatuModal(row)}>
                {(cell === 1 ? "Disable" : "Enable")}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={() => this.openDeleteModal(row)} >
                Hapus
              </DropdownItem>
            </>
          ) : (
            <DropdownItem>
              {(cell === 1 ? "Aktif" : "Tidak Aktif")}
            </DropdownItem>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    )
  };

  toggleModalChangeStatus = () => {
    this.setState((prevState) => ({
      modalChangeStatus: !prevState.modalChangeStatus,
    }));
  };

  toggleModalDeleteUser = () => {
    this.setState((prevState) => ({
      modalDeleteUser: !prevState.modalDeleteUser,
    }));
  };

  toggleModalChangePassword = () => {
    this.setState((prevState) => ({
      modalChangePassword: !prevState.modalChangePassword
    }));
  }

  openModalChangePassword = (u) => {
    this.setState((prevState) => ({
      modalChangePassword: !prevState.modalChangePassword,
      selectedUser: u
    }));
  }

  handleDeleteUser = () => {
    this.props
      .deleteUser({
        dispatch: "",
        title: "User",
        path: `user/${this.state.selectedUser.id}`,
      })
      .then(() => {
        this.toggleModalDeleteUser();
        this.getData();
      });
  }

  formatterRoles = (cell) => {
    return (
      <p>
        {cell === 1
          ? "Admin"
          : cell === 2
          ? "Gubernur"
          : cell === 3
          ? "Biro"
          : cell === 4
          ? "Komisaris"
          : cell === 5
          ? "Direksi"
          : cell === 6
          ? "Keuangan"
          : cell === 7
          ? "IT"
          : cell === 8
          ? "SDM"
          : ""}
      </p>
    );
  };

  handleSearch = (event) => {
    this.setState(
      {
        searchName: event.target.value,
      },
      () => {
        if (this.state.typingTimeout) {
          clearTimeout(this.state.typingTimeout);
        }

        this.setState({
          typingTimeout: setTimeout(() => {
            this.getDataTable();
          }, 100),
        });
      }
    );
  };

  render() {
    const { dataTable } = this.props;
    const { modalChangeStatus, modalChangePassword, loading, modalDeleteUser } = this.state;

    const columns = [
      {
        dataField: "name",
        text: "Nama",
        // headerStyle: () => ({ width: "30%", textAlign: "left" }),
      },
      {
        dataField: "email",
        text: "Email",
      },
      {
        dataField: "role",
        text: "Hak Akses",
        formatter: this.formatterRoles,
      },
      {
        dataField: "perusahaan.nama",
        text: "Perusahaan",
      },
    ];

    const columnsBiro = [
      ...columns,
      {
        dataField: "status",
        text: "Aksi",
        formatter: this.formatterStatus,
        headerStyle: () => ({ width: "15%" }),
      },
    ]

    return (
      <>
        <HeaderComp getData={this.getData} />
        <LoadingTop />
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container shadow-sm py-3 border-0">
                <div className="row">
                  <div className="col-md-6 order-md-1 order-2">
                    <Input
                      onKeyUp={this.handleSearch}
                      icon
                      iconPosition="left"
                      className="w-100 mb-3"
                      placeholder="Cari Akun"
                    >
                      <input />
                      <Icon name="search" />
                    </Input>
                  </div>
                  <div className="col-md-6 order-md-2 order-1 d-flex align-items-center justify-content-md-end mb-md-0 mb-3">
                    {this.props.user.role < 4 && (
                      <>
                        <label className="mr-3">Perusahaan</label>
                        <SelectPerusahaan options={{value: "", text: "Semua"}} name="perusahaanId" />
                      </>
                    )}
                  </div>
                </div>
                <TableComp
                  data={dataTable || []}
                  columns={isBiro() ? columnsBiro : columns}
                  getDataTable={this.handlePagginateTable}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={modalChangeStatus} toggle={this.toggleModalChangeStatus}>
          <ModalBody className="text-center my-3">
            <Icon color="red" name="user outline" size="large" />
            <h3>Ubah Status User</h3>
            <p>
              {`Apakah anda yakin akan ${
                this.state.selectedUser?.status === 0
                  ? "mengaktifkan"
                  : "menonaktifkan"
              } Akun ${this.state.selectedUser?.name}?`}
            </p>
            <div>
              <Button color="grey" onClick={this.toggleModalChangeStatus}>
                Cancel
              </Button>
              <Button
                className="mr-3"
                color="blue"
                onClick={this.changeUserStatus}
              >
                Submit
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modalDeleteUser} toggle={this.toggleModalChangeStatus}>
          <ModalBody className="text-center my-3">
            <Icon color="red" name="user outline" size="large" />
            <h3>Konfirmasi</h3>
            <p>
              {`Apakah anda yakin akan menghapus Akun ${this.state.selectedUser?.name}?`}
            </p>
            <div>
              <Button color="grey" onClick={this.toggleModalDeleteUser}>
                Cancel
              </Button>
              <Button
                className="mr-3"
                color="red"
                onClick={this.handleDeleteUser}
              >
                Delete
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modalChangePassword} toggle={this.toggleModalChangePassword}>
          <ModalHeader toggle={this.toggleModalChangePassword}>Ubah Password</ModalHeader>
          <ModalBody>
            <Form>
              <div className="container">
                {`Silahkan masukan pasword baru untuk Akun ${this.state.selectedUser?.name}!`}
                <PasswordInput
                  type="password"
                  name="password"
                  onChange={e => this.handlePasswordInput(e.target.value)}
                  placeholder="Password Baru"
                  className="mt-2"
                  required
                />
              </div>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="grey" onClick={this.toggleModalChangePassword}>
              Cancel
            </Button>
            <Button
              color="blue"
              onClick={this.handleChangePassword}
              loading={loading}
            >
              Ubah Password
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
const reduxState = (state) => {
  return {
    user: state.main.dataUser,
    dataTable: state.akunReducer.dataTable,
    filter: state.main
  };
};

const reduxDispatch = (dispatch) => ({
  getData: (data) => dispatch(getDataAction(data)),
  changeStatus: (data) => dispatch(editDataAction(data)),
  changePassword: (data) => dispatch(editDataAction(data)),
  deleteUser: (data) => dispatch(deleteDataAction(data)),
});

export default connect(reduxState, reduxDispatch)(Akun);
